import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, TwitterIcon, FacebookIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="w-full bg-[#050505] border-t border-[#C9A84C]/20" data-id="element-193">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8" data-id="element-194">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-195">
          <h2 className="font-montserrat font-black text-3xl tracking-widest text-[#C9A84C]" data-id="element-196">
            MK LOUNGE DC
          </h2>
          <div className="w-24 h-px bg-[#C9A84C]/30 mx-auto mt-4" data-id="element-197" />
        </motion.div>

        {/* 4-column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14" data-id="element-198">
          {/* About */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0
        }} data-id="element-199">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-200">
              ABOUT
            </h4>
            <p className="font-inter font-light text-white/50 text-sm leading-relaxed" data-id="element-201">
              Washington DC's most exclusive nightlife destination. Where luxury
              meets the night.
            </p>
            <div className="flex gap-3 mt-5" data-id="element-202">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C9A84C]/30 text-[#C9A84C]/70 hover:border-[#C9A84C] hover:text-[#C9A84C] transition-all duration-300" aria-label="Instagram" data-id="element-203">
                <InstagramIcon size={15} data-id="element-204" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C9A84C]/30 text-[#C9A84C]/70 hover:border-[#C9A84C] hover:text-[#C9A84C] transition-all duration-300" aria-label="Twitter" data-id="element-205">
                <TwitterIcon size={15} data-id="element-206" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C9A84C]/30 text-[#C9A84C]/70 hover:border-[#C9A84C] hover:text-[#C9A84C] transition-all duration-300" aria-label="Facebook" data-id="element-207">
                <FacebookIcon size={15} data-id="element-208" />
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-209">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-210">
              QUICK LINKS
            </h4>
            <ul className="space-y-2.5" data-id="element-211">
              {['EVENTS', 'RESERVATIONS', 'BOTTLE SERVICE', 'GALLERY', 'PRESS'].map(link => <li key={link} data-id="element-212">
                  <a href="#" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors duration-300 flex items-center gap-2 group" data-id="element-213">
                    <span className="w-3 h-px bg-[#C9A84C]/30 group-hover:w-5 group-hover:bg-[#C9A84C] transition-all duration-300" data-id="element-214" />
                    {link}
                  </a>
                </li>)}
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-215">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-216">
              CONTACT
            </h4>
            <ul className="space-y-3" data-id="element-217">
              <li className="flex items-start gap-3" data-id="element-218">
                <MapPinIcon size={14} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-219" />
                <span className="font-inter font-light text-sm text-white/50" data-id="element-220">
                  1234 K Street NW
                  <br data-id="element-221" />
                  Washington, DC 20005
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-222">
                <PhoneIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-223" />
                <a href="tel:+12025550100" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors" data-id="element-224">
                  (202) 555-0100
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-225">
                <MailIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-226" />
                <a href="mailto:vip@mkloungedc.com" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors" data-id="element-227">
                  vip@mkloungedc.com
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Hours */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-228">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-229">
              HOURS
            </h4>
            <ul className="space-y-2" data-id="element-230">
              {[{
              day: 'Thursday',
              hours: '9 PM — 2 AM'
            }, {
              day: 'Friday',
              hours: '10 PM — 3 AM'
            }, {
              day: 'Saturday',
              hours: '10 PM — 4 AM'
            }, {
              day: 'Sunday',
              hours: '8 PM — 1 AM'
            }].map(({
              day,
              hours
            }) => <li key={day} className="flex justify-between items-center" data-id="element-231">
                  <span className="font-inter font-light text-sm text-white/50" data-id="element-232">
                    {day}
                  </span>
                  <span className="font-inter text-xs text-[#C9A84C]/80" data-id="element-233">
                    {hours}
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 p-3 bg-[#C9A84C]/10 border border-[#C9A84C]/20 rounded-lg" data-id="element-234">
              <p className="font-montserrat text-[9px] tracking-widest text-[#C9A84C] mb-1" data-id="element-235">
                DRESS CODE
              </p>
              <p className="font-inter text-xs text-white/60" data-id="element-236">
                Upscale attire required. Management reserves the right of
                admission.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#C9A84C]/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-237">
          <p className="font-inter font-light text-xs text-white/30" data-id="element-238">
            © 2025 MK Lounge DC. All rights reserved.
          </p>
          <p className="font-inter font-light text-xs text-white/20 italic" data-id="element-239">
            Crafted for the night
          </p>
          <div className="flex gap-4" data-id="element-240">
            <a href="#" className="font-inter text-xs text-white/30 hover:text-[#C9A84C]/60 transition-colors" data-id="element-241">
              Privacy
            </a>
            <a href="#" className="font-inter text-xs text-white/30 hover:text-[#C9A84C]/60 transition-colors" data-id="element-242">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}